import { useFieldValue, useFormState } from 'form-atoms'
import { swapFormAtom } from '@/src/stores/swap/atoms'

export function useFormFilled() {
  const { fieldAtoms } = useFormState(swapFormAtom)
  const fromAmount = useFieldValue(fieldAtoms.fromAmount)
  return Number(fromAmount) > 0
}
